"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const ReviewQuery = (0, graphql_tag_1.default) `
  query reviewQuery(
    $productId: String
    $reviewPage: Int = 1
    $reviewPageSize: Int
    $reviewSortType: String
    $reviewSortOrientation: String
  ) {
    review(
      reviewRequest: {
        id: $productId
        pagination: { page: $reviewPage, size: $reviewPageSize }
        sort: { type: $reviewSortType, orientation: $reviewSortOrientation }
      }
    ) {
      stats {
        count
        average
        distribution {
          value
          count
        }
        characteristics {
          label
          value
        }
      }
      reviews {
        title
        text
        rating
        recommended
        user {
          name
        }
        date
        characteristics {
          label
          value
        }
      }
      sorts {
        type
        orientation
        label
      }
      pagination {
        page
        pages
        size
        start
      }
    }
  }
`;
exports.default = ReviewQuery;
